import removeLazyLoadingAttributeFromImages from './remove-lazy-loading-attribute-from-images';

export default { removeLazyLoadingAttributeFromImages };
